import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantPreviousResidencePage = {
  alert: {
    error: 'applicant-previous-residence.alert.error',
  },
  footer: {
    root: 'applicant-previous-residence.footer.root',
  },
  form: {
    addressLine1Input: 'applicant-previous-residence.form.address-line-1-input',
    addressLine1InputError:
      'applicant-previous-residence.form.address-line-1-input-error',
    addressLine2Input: 'applicant-previous-residence.form.address-line-2-input',
    cityInput: 'applicant-previous-residence.form.city-input',
    cityInputError: 'applicant-previous-residence.form.city-input-error',
    h1: 'applicant-previous-residence.form.h1',
    h2: 'applicant-previous-residence.form.h2',
    root: 'applicant-previous-residence.form.root',
    stateSelect: 'applicant-previous-residence.form.state-select',
    stateSelectError: 'applicant-previous-residence.form.state-select-error',
    submitButton: 'applicant-previous-residence.form.submit-button',
    zipCodeInput: 'applicant-previous-residence.form.zip-code-input',
    zipCodeInputError: 'applicant-previous-residence.form.zip-code-input-error',
  },
  header: {
    drawerButton: 'applicant-previous-residence.header.drawer-button',
    previousStepButton:
      'applicant-previous-residence.header.previous-step-button',
    root: 'applicant-previous-residence.header.root',
  },
  progress: {
    root: 'applicant-previous-residence.progress.root',
  },
} as const satisfies PageLocatorMap;
